import config from 'emun.retailer/retailer.config'
import retailerConfig from 'emun.retailer/retailer.config'
import templateUrl from 'emun.invoice/invoice-view.htm'
import Product from 'emun.shopping/product.model'
import $appConfig from 'servicestack/config'


class InvoiceViewController {
  constructor(createAutoQuery) {
    let options = {
      url: 'QueryInvoices.json?Id=' + this.invoiceId,
      autoLoad: true,
      onLoaded: args => this.invoice = args.first
    };
    this.query = createAutoQuery(options);

    this.queryLines = createAutoQuery({
      url: 'QueryInvoiceLines.json?InvoiceNumber=' + this.invoiceId,
      take: 3000,
      autoLoad: true,
      onLoaded: args => this.invoiceLines = args.results.map(line => Object.assign(line, {
        product: new Product(line.product || {})
      }))
    });
    this.hideParcels = (config.hideParcels === true);
    this.config = retailerConfig;
    this.productImage = $appConfig.productImage.bind($appConfig);
  }
  load() { return this.query.load.apply(this.query, arguments); }
}

const InvoiceView = {
  bindings: {
    invoiceId: '@',
  },
  controller: InvoiceViewController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default InvoiceView;